import { format, startOfWeek, addDays, parseISO, isSameDay } from "date-fns";
import { es } from "date-fns/locale";

export function pesos(n) {
  if (n == null || isNaN(n)) return "—";
  return "$ " + Math.round(n).toLocaleString("es-AR");
}

export function m2(n) {
  return `${n} m²`;
}

export function fechaCorta(d) {
  const date = typeof d === "string" ? parseISO(d) : d;
  return format(date, "dd/MM/yyyy", { locale: es });
}

export function fechaLarga(d) {
  const date = typeof d === "string" ? parseISO(d) : d;
  return format(date, "EEEE d 'de' MMMM", { locale: es });
}

export function hora(d) {
  const date = typeof d === "string" ? parseISO(d) : d;
  return format(date, "HH:mm", { locale: es });
}

export function mesAnio(d) {
  const date = typeof d === "string" ? parseISO(d) : d;
  return format(date, "MMMM yyyy", { locale: es });
}

export function inicioSemana(base = new Date()) {
  return startOfWeek(base, { weekStartsOn: 1 });
}

export function diasSemana(base = new Date()) {
  const ini = inicioSemana(base);
  return Array.from({ length: 7 }, (_, i) => addDays(ini, i));
}

export { addDays, isSameDay, parseISO, format };
